import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/pennyworld/island6-removebg.png")